import data from './data.json';

const getData = () => {
  return data;
};

export default getData;